// extracted by mini-css-extract-plugin
export var acitonButtons = "_he-0";
export var additionalIcon = "_he-f";
export var block = "_he-1";
export var blockContent = "_he-7";
export var blockDescription = "_he-8";
export var blockIcon = "_he-9";
export var blockTitle = "_he-6";
export var border = "_he-a";
export var center = "_he-l";
export var edge = "_he-b";
export var edgeLabel = "_he-c";
export var edgePath = "_he-d";
export var error = "_he-e";
export var flowchart = "_he-g";
export var flowchartContent = "_he-h";
export var highlighted = "_he-3";
export var hover = "_he-4";
export var icon = "_he-i";
export var left = "_he-m";
export var navButton = "_he-j";
export var navButtons = "_he-k";
export var right = "_he-n";
export var selected = "_he-2";
export var small = "_he-5";